<template>
    <v-row class="card-container pa-3" align="center" v-if="currentPlan">
        <v-col cols="4" class="text-center">
            <div class="img-container">
                <v-img :src="planImg" max-width="46" class="mx-auto"/>
            </div>
        </v-col>
        <v-col cols="8">
            <div class="card-text">
                {{ $t('common.current_plan') }}
            </div>
            <div class="plan-name">
                {{ currentPlan.name }}
            </div>
        </v-col>
        <v-col cols="12">
            <span class="plan-price">
                ${{ currentPlan.amount }}
            </span>
            <span class="card-text">
                {{ currentPlan.currency }} {{ currentPlan.interval }}
            </span>
        </v-col>
        <v-col cols="12" class="card-text py-0">
            {{ $t('common.include') }}
        </v-col>
        <v-col cols="12" class="card-text">
            <v-row v-for="(feature,i) in features" :key="i" dense align="center">
                <v-col cols="2" class="text-center">
                    <v-avatar color="#FFFFFF" size="25">
                        <v-icon color="#99CC00" size="17">$check</v-icon>
                    </v-avatar>
                </v-col>
                <v-col cols="10">
                    {{ feature }}
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12">
            <v-btn class="b-primary" block style="border-radius: 96px;" @click="toChangePlan" depressed>
                {{ $t('common.change_plan') }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "CurrentSubscriptionCard",
    props: {
        priceId: {
            type: String,
            default: null
        }
    },
    computed: {
        ...mapState(['plans']),
        currentPlan(vm = this) {
            if (vm.plans.length === 0) return null
            return vm.plans.find(plan => plan.priceId === vm.priceId)
        },
        planImg(vm = this) {
            return vm.currentPlan?.img || vm.imgPlaceholder
        },
        features(vm = this) {
            let features = []
            if(!vm.currentPlan) return features
            if(vm.currentPlan.premium) features.push(vm.$t('common.premium_support'))
            features.push(vm.currentPlan.maxClients ? vm.$t('common.max_clients', {max: vm.currentPlan.maxClients}) : vm.$t('common.unlimited_clients'))
            return features
        }
    },
    async mounted() {
        const vm = this
        await vm.loadPlans()
    },
    methods: {
        ...mapActions(['bindPlans', 'bindCompanyPlans']),
        toChangePlan() {
            const vm = this
            vm.$router.push({name: `${vm.accountType}.profile.edit`, params: {mode: 'SelectPlan'}})
        },
        async loadPlans() {
            const vm = this
            if (vm.plans.length === 0 && vm.account.accountType) {
                vm.account.accountType === 'company' ?
                    await vm.bindCompanyPlans() :
                    await vm.bindPlans()
            }
        }
    },
    watch: {
        account() {
            this.loadPlans()
        }
    }
}
</script>

<style scoped>

.card-container {
    background: #333333;
    border: 1px solid #EFF0F7;
    box-shadow: 0px 2px 12px rgba(20, 20, 43, 0.08);
    border-radius: 24px;
}

.img-container {
    display: inline-block;
    background: #FFFFFF;
    border-radius: 16px;
    padding: 4px;
}

.card-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #EFF0F7;
}

.plan-name {
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    color: #FFFFFF;
}

.plan-price {
    font-weight: 700;
    font-size: 36px;
    line-height: 40px;
    color: #FFFFFF;
}

</style>